'use strict';
import * as T from 'prop-types';
import React, {Component} from 'react';
import {getDomainInstance} from '../../../core-utilities/domain/ReduxUtils';
import {getMessagesFromProps} from '../../../core-utilities/react-i18n';
import taskScheduleModalTemplate from '../../controllers/task-schedule-modal.html';
import {getPermissions, TaskScheduleDialogController} from '../../controllers/TaskScheduleDialogController';
import {isScheduleModalMode, ScheduleModalMode} from '../../enums/ScheduleModalMode';
import {getAccessors} from '../../utils';
import {logger} from '../logger';
import {TaskAssignmentView} from './TaskAssignmentView';


export class TaskAssignmentComponent extends Component {
  static propTypes = {
    className: T.string,
    showTargetName: T.bool,
    type: T.oneOf([
      'auto',
      'scheduled',
      'submitted',
      'approved',
      'cancelled',
      'rejected',
    ]),
    model: T.object,
    permissions: T.object,
    scheduleModalMode: isScheduleModalMode,

    init: T.bool,
  };

  static defaultProps = {
    type: 'auto',
    scheduleModalMode: ScheduleModalMode.local,
    noAssignmentLabel: '',
    showTargetName: false,

    init: true,
  };

  static $inject = [
    '$modal',
    '$permissions',
  ];

  static messages = TaskAssignmentView.messages;
  static messageProps = TaskAssignmentView.messageProps;

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  /**
   * @param {MouseEvent} e
   * @private
   */
  handleClick(e) {
    e.stopPropagation();
    const {
      model,
      permissions,
      scheduleModalMode,
    } = this.props;

    TaskAssignmentComponent.openAssignmentDialog(model, permissions, scheduleModalMode)
      .catch(err => {
        if (err && err.message) {
          logger.error({err}, `Assignment Dialog failed with error="${err.message}"`);
        }
      });
  }

  render() {
    const props = this.props;
    const {
      timeLabel,
      getIcon,
      getDate,
      getUseTime,
      getTarget,
    } = getAccessors(props.type, props.model);

    if (!getTarget) {
      // TODO: improve this. Must fail gracefully if data is unexpected and probably warn the developer
      return null;
    }

    return (
      <TaskAssignmentView
        className={props.className}
        iconClass={getIcon(props.model)}
        date={getDate(props.model)}
        useTime={getUseTime(props.model)}
        timeLabel={timeLabel}
        target={getTarget(props.model)}
        showTargetName={props.showTargetName}

        onClick={this.handleClick}

        init={props.init}
        {...getMessagesFromProps(props, TaskAssignmentView.messageProps)}
      />
    );
  }

  /**
   * @param {Object} task
   * @param {Object<String, Boolean>} permissions
   * @param {'local','foreign'} mode
   */
  static openAssignmentDialog(task, permissions, mode) {
    const $modal = TaskAssignmentComponent.dependencies.$modal;
    const $permissions = TaskAssignmentComponent.dependencies.$permissions;

    return Promise.all([
      permissions ? Promise.resolve(permissions) : getPermissions($permissions, task),
      getDomainInstance(task),
    ]).then(data =>
      $modal.show({
        template: taskScheduleModalTemplate,
        controller: TaskScheduleDialogController,
        locals: {task: data[1], permissions: data[0], mode},
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskAssignment/TaskAssignmentComponent.js